// action types
import { createRequestTypes } from "../../utils";

// Fetch Approve Pending Images
export const FETCH_APPROVE_PENDING_IMAGES = createRequestTypes("FETCH_APPROVE_PENDING_IMAGES");

export const fetchApprovePendingImagesRequest = () =>
    ({ type: FETCH_APPROVE_PENDING_IMAGES.REQUEST });

export const fetchApprovePendingImagesSuccess = (data) =>
    ({ type: FETCH_APPROVE_PENDING_IMAGES.SUCCESS, payload: { data } });

export const fetchApprovePendingImagesFailure = (error) =>
    ({ type: FETCH_APPROVE_PENDING_IMAGES.FAILURE, payload: error });

// Update Pending Images
export const UPDATE_PENDING_IMAGES = createRequestTypes("UPDATE_PENDING_IMAGES");

export const updatePendingImagesRequest = (image_id, is_approved) =>
    ({ type: UPDATE_PENDING_IMAGES.REQUEST, payload: { image_id, is_approved } });

export const updatePendingImagesSuccess = () =>
    ({ type: UPDATE_PENDING_IMAGES.SUCCESS });

export const updatePendingImagesFailure = (error) =>
    ({ type: UPDATE_PENDING_IMAGES.FAILURE, payload: { error } });